import './_autocomplete-search-product-hits.scss';
import component from './autocomplete-search-product-hits';

export default component;
